module.exports = __webpack_public_path__ + "img/profitability8.f9bedbcf.png";